import './button.scss';

import React, { FC, MouseEvent } from 'react';
import { Button } from 'react-bootstrap';

interface ButtonProps {
  onClick(event: MouseEvent<HTMLButtonElement>): void;
  buttonLabel: string;
  styleClass?: string;
  buttonStyling?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  ariaLabel?: string;
  disabled?: boolean;
  dataTestId?: string;
  iconRight?: React.ReactNode;
}

const DefaultButton: FC<ButtonProps> = ({
  onClick,
  buttonLabel,
  styleClass,
  buttonStyling,
  type,
  ariaLabel,
  disabled,
  dataTestId,
  iconRight,
}) => {
  return (
    <Button
      disabled={disabled}
      type={type}
      aria-label={ariaLabel}
      className={styleClass}
      style={buttonStyling}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {buttonLabel}
      {iconRight && <span className='icon-right'>{iconRight}</span>}
    </Button>
  );
};

export default DefaultButton;
